<template>
  <div class="block" v-if="total > 0">
    <div class="left" v-if="reserve"
      >选中{{ multipleSelectionTotal }}条,显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
      {{
        (page.pageNum - 1) * page.pageSize + page.pageSize > total
          ? total
          : (page.pageNum - 1) * page.pageSize + page.pageSize
      }}
      条记录，共 {{ total }} 条记录</div
    >
    <div class="left" v-else
      >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
      {{
        (page.pageNum - 1) * page.pageSize + page.pageSize > total
          ? total
          : (page.pageNum - 1) * page.pageSize + page.pageSize
      }}
      条记录，共 {{ total }} 条记录</div
    >
    <el-pagination
      v-if="total > 0"
      class="right"
      ref="page"
      background
      @size-change="handleSizeChange"
      @current-change="handlePagination"
      :page-count="page.pages"
      :current-page="page.pageNum || 1"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page.pageSize"
      :total="total"
      layout="sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'IPagination',
    props: {
      total: {
        type: Number,
        default: 0,
      },
      //是否需要翻页选中
      reserve: {
        type: Boolean,
        default: true,
      },
      multipleSelection: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
        },
        multipleSelectionTotal: 0,
      };
    },
    methods: {
      //抛出选择每页条数事件
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.$emit('changePageHandler', this.page.pageNum, val);
      },
      //抛出当前页数跳转事件
      handlePagination(val) {
        this.page.pageNum = val;
        this.$emit('changePageHandler', val, this.page.pageSize);
      },
    },
    watch: {
      multipleSelection: {
        handler(val) {
          if (val) {
            this.multipleSelectionTotal = val.length;
          } else {
            this.multipleSelectionTotal = 0;
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .block {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-pagination {
      display: inline-block;
    }
    .left {
      color: #999999;
      font-size: 12px;
    }
    .right {
      ::v-deep .active:hover {
        color: #ffffff !important;
      }
    }
  }
</style>
